import React from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom';

import Console from './components/Console/Console';
import LoginPage from './components/LoginPage/LoginPage';
import './App.css';

import { library } from '@fortawesome/fontawesome-svg-core'
import { faSignOutAlt } from '@fortawesome/free-solid-svg-icons'
import { faCircle, faTimesCircle, faThumbtack, faMicrophone } from '@fortawesome/free-solid-svg-icons'
import { faVolumeMute, faVolumeUp } from '@fortawesome/free-solid-svg-icons'
import { faPhone, faPhoneAlt, faPhoneSlash } from '@fortawesome/free-solid-svg-icons'
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons'
import { faQuestion } from '@fortawesome/free-solid-svg-icons'

library.add(faTimesCircle, faThumbtack, faPhoneAlt, faSignOutAlt,
            faMicrophone, faVolumeMute, faVolumeUp, faPhone,
            faPhoneSlash, faCircle, faEye, faEyeSlash, faQuestion)

const Login = () => (
  <LoginPage />
);

const App = () => (
  <BrowserRouter>
    <Switch>
      <Route path="/console">
        <Console />
      </Route>
      <Route path="/">
        <Login />
      </Route>
    </Switch>
  </BrowserRouter>
);


export default App;
